module.exports = __webpack_public_path__ + "static/back4-07f2916f4382fc397ea6806f9f9d2020.png";